import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import { PROFESSIONAL_ANNUALY, PROFESSIONAL_MONTHLY } from '../../util/types';
import css from './StripeSubscriptionPanel.module.css';
import { useDispatch, useSelector } from 'react-redux';
import SubscriptionCustomCard from './SubscriptionCustomCard';
import classNames from 'classnames';
import { freePlan, getStripeCustomerId, isEmailVerified } from '../../util/helper';
import Modal from '../Modal/Modal';
import { manageDisableScrolling } from '../../ducks/ui.duck';
import { SubscriptionCardPayment } from '..';
import starIcon from '../../assets/image/star.svg';

const StripeSubscriptionCard = props => {
  const {
    currentUser,
    handleSubscription,
    userName,
    createSubscriptionInProgress,
    setCardPaymentModal,
    cardPaymentModal,
    onlineSubscriptionData,
    subscriptionPlan,
  } = props;

  const currentSubscription = onlineSubscriptionData?.filter(
    item => item.attributes.status == 'active'
  );
  const isActive = currentSubscription[0]?.attributes?.status == 'active';
  const [modalState, setModalState] = useState(false);
  const dispatch = useDispatch();

  const merchantImage = currentUser?.profileImage?.attributes?.variants['square-small']?.url;
  const { firstName, lastName } = currentUser?.attributes?.profile || '';
  const fullName = firstName + ' ' + lastName || '';

  const pricePlan = subscriptionPlan && subscriptionPlan.length > 0 ? subscriptionPlan[0] : {};

  return (
    <div className={css.stripeSubscriptionCardContainer}>
      <div className={css.striprSubscriptionCover}>
        <div className={css.billingToggle}>
          <div className={css.billingHeading}>
            <FormattedMessage id="StripeSubscriptionCard.transparentPricing" />
          </div>
          {isActive && (
            <div className={css.profileBox}>
              <div className={css.profileCover}>
                <img src={merchantImage} className={css.profileIcon} alt={'meme'} />
                <span>
                  <img src={starIcon} />
                </span>
              </div>
              <div className={css.profileDetails}>
                <div className={css.profileHeading}>{fullName}</div>
                <div className={css.proBadge}>
                  <span>Pro Star</span>
                </div>
              </div>
            </div>
          )}
          <ul className={css.billList}>
            <li>
              <span>Increased Visibility:</span> Boost your profile in our seller directory and get
              seen by more customers (where applicable).
            </li>
            <li>
              <span>Exclusive Discounts:</span> Enjoy regular, exclusive discounts on your credit
              packs as a Pro Star member.
            </li>
            <li>
              <span>Stand Out in Search:</span> Achieve higher ranks in SEO search results, making
              your profile more prominent.
            </li>
            <li>
              <span>Enhanced Trust:</span> Build credibility with a Pro Star badge, showcasing your
              commitment to excellence.
            </li>
            <li>
              <span>Early Access:</span> Be the first to try new features and updates on the
              MyFindor marketplace.
            </li>
            <li>
              <span>Enhanced Listings:</span> Use rich media and detailed descriptions to create
              more attractive and informative product listings.
            </li>
          </ul>
        </div>
      </div>
      <div className={css.subscriptionHeadingTable}>
        <div className={css.tableRowLine}>
          <div className={css.subscriptionPlansMap}>
            {subscriptionPlan?.length
              ? subscriptionPlan.map((plan, i) => {
                  const planName = plan.nickname;

                  return planName ? (
                    <SubscriptionCustomCard
                      key={plan.id}
                      plan={plan}
                      handleSubscription={handleSubscription}
                      modalState={modalState}
                      setModalState={setModalState}
                      currentUser={currentUser}
                      userName={userName}
                      createSubscriptionInProgress={createSubscriptionInProgress}
                      cardPaymentModal={cardPaymentModal}
                      setCardPaymentModal={setCardPaymentModal}
                      currentSubscription={currentSubscription}
                      isActive={isActive}
                    />
                  ) : null;
                })
              : null}
          </div>

          <div>
            <Modal
              id="offlinePaymentModal"
              className={css.disableModalBorder}
              contentClassName={css.containerClassName}
              isOpen={cardPaymentModal}
              onClose={() => setCardPaymentModal(false)}
              usePortal
              onManageDisableScrolling={(componentId, disableScrolling) =>
                dispatch(manageDisableScrolling(componentId, disableScrolling))
              }
            >
              <label> Add Card</label>
              <SubscriptionCardPayment
                currentUser={currentUser}
                dispatch={dispatch}
                onClose={e => {
                  setCardPaymentModal(false), handleSubscription(e, pricePlan);
                }}
              />
            </Modal>
          </div>
        </div>
      </div>
      <div className={css.overflowTable}></div>
    </div>
  );
};

export default StripeSubscriptionCard;
